import './SpinnerLoading.css';

function SpinnerLoading(){
    return(
        <div className='spinner-loading-container'>
            <div className='spinner-loading'>
                <span className='loader'></span>

                <p>Las mejores marcas en homesleep.pe</p>
            </div>
        </div>
    )
}

export default SpinnerLoading;
